






































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import VueTagsInput from '@johmun/vue-tags-input';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import InstitutionModel from '../../dex-shared/models/InstitutionModel';
import ExaminationBoardModel from '../../dex-shared/models/ExaminationBoardModel';

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
    VueTagsInput,
  },

  data() {
    return {
      creating: true,
      pushing: false,
      institutionTags: [],
      institutionTag: '',
      examinationBoardTags: [],
      examinationBoardTag: '',
    };
  },

  computed: {
    ...mapGetters({
      examApplication: 'currentExamApplication',
      allExaminationBoards: 'allExaminationBoards',
      allInstitutions: 'allInstitutions',
    }),
    filteredInstitutions() {
      return this.allInstitutions
        .map((institution: InstitutionModel) => institution.raw())
        .filter((institution: any) => {
          return (
            institution.title
              .toLowerCase()
              .indexOf(this.institutionTag.toLowerCase() || '') !== -1
          );
        })
        .map((institution: any) => {
          return {
            ...institution,
            text: institution.title,
          };
        });
    },
    filteredExaminationBoards() {
      return this.allExaminationBoards
        .map((examinationBoard: ExaminationBoardModel) =>
          examinationBoard.raw(),
        )
        .filter((examinationBoard: any) => {
          return (
            examinationBoard.title
              .toLowerCase()
              .indexOf(this.examinationBoardTag.toLowerCase() || '') !== -1
          );
        })
        .map((examinationBoard: any) => {
          return {
            ...examinationBoard,
            text: examinationBoard.title,
          };
        });
    },
  },

  async created() {
    this.creating = this.$route.name === 'exam_application_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_EXAM_APPLICATION');
    } else {
      let examApplicationId = parseInt(this.$route.params.examApplicationId);
      await this.$store.dispatch('PULL_EXAM_APPLICATION', examApplicationId);
      //TODO no exam application found
    }
    this.$store.dispatch('PULL_EXAMINATION_BOARDS', { resultsPerPage: 1000 });
    await this.$store.dispatch('PULL_INSTITUTIONS', { resultsPerPage: 1000 });
  },

  methods: {
    pushExamApplication: async function() {
      // TODO check if exam application already exists
      if (this.pushing === false) {
        this.pushing = true;
        let error;
        try {
          await this.$store.dispatch(
            'PUSH_EXAM_APPLICATION',
            this.examApplication,
          );
        } catch (e) {
          error = e;
          alert(
            `Algo deu errado! Envie essa mensagem aos desenvolvedores: ${e}`,
          );
        }
        this.pushing = false;
        if (!error) this.$router.push(`/fontes`);
      }
    },
    goHome() {
      this.$router.push('/fontes');
    },
    setInstitution(institution: any) {
      this.examApplication.institution = institution[0];
    },
    setExaminationBoard(examinationBoard: any) {
      this.examApplication.examinationBoard = examinationBoard[0];
    },
  },
});
